<template>
  <div class="temp-wrapper position-relative h-100">
    <div v-if="templateId == 1">
      <div class="template1">
        <template-1
          class="template-container-bigger"
          :template-data="templateData"
          :editor-data="editorData"
          :editor-select-id="editorSelectId"
          :is-active="isActive"
          @onSelectEditor="onSelectEditor"
          @onReorder="onReorder"
        />
      </div>
    </div>
    <div v-if="templateId == 2">
      <div class="template2">
        <template-2
          class="template-container-bigger"
          :template-data="templateData"
          :editor-data="editorData"
          :editor-select-id="editorSelectId"
          :is-active="isActive"
          @onSelectEditor="onSelectEditor"
          @onReorder="onReorder"
        />
      </div>
    </div>
    <div v-if="templateId == 3">
      <div class="template3">
        <template-type-3
          class="template-container-bigger"
          :template-data="templateData"
          :editor-data="editorData"
          :editor-select-id="editorSelectId"
          :is-active="isActive"
          @onSelectEditor="onSelectEditor"
          @onReorder="onReorder"
        />
      </div>
    </div>
    <!-- <div v-if="templateId == 4">
      <div class="template4">
        <template-4
          class="template-container-bigger"
          :template-data="templateData"
          :editor-data="editorData"
          :editor-select-id="editorSelectId"
          :is-active="isActive"
          @onSelectEditor="onSelectEditor"
          @onReorder="onReorder"
        />
      </div>
    </div>
    <div v-if="templateId == 5">
      <div class="template5">
        <template-5
          class="template-container-bigger"
          :template-data="templateData"
          :editor-data="editorData"
          :editor-select-id="editorSelectId"
          :is-active="isActive"
          @onSelectEditor="onSelectEditor"
          @onReorder="onReorder"
        />
      </div>
    </div> -->
  </div>
</template>

<script>
import {
  onBeforeMount,
  reactive,
  ref,
  watch,
  computed,
  getCurrentInstance,
} from "@vue/composition-api";
import Template1 from "./Template1.vue";
import Template2 from "./Template2.vue";
import Template3 from "./Template3.vue";
import TemplateType3 from "./TemplateType3.vue";
import Template4 from "./Template4.vue";
import Template5 from "./Template5.vue";

export default {
  components: {
    Template1,
    Template2,
    Template3,
    TemplateType3,
    Template4,
    Template5,
  },
  props: {
    templateId: { type: [Number, String], default: 1 },
    templateData: { type: [Object, Array], default: null },
    editorData: { type: Object, default: null },
    editorSelectId: null,
    isActive: { type: Boolean, default: false },
  },
  setup(props) {
    const vm = getCurrentInstance().proxy;

    const onSelectEditor = (event, isRemove) => {
      vm.$emit("onSelectEditor", event, isRemove);
    };

    const onReorder = (event) => {
      vm.$nextTick(() => {
        vm.$emit("onReorder", event);
      });
    };

    return { onSelectEditor, onReorder };
  },
};
</script>
